export type ScheduledMode = 'single' | 'multiple' | 'file' | 'reminder';
export type ScheduledStatus =
  | 'pending'
  | 'processing'
  | 'sent'
  | 'partial'
  | 'failed'
  | 'cancelled';
export interface ScheduledRecipient {
  phone: string;
  message: string;
}
export interface ScheduleJobInput {
  name: string;
  mode: ScheduledMode;
  recipients: ScheduledRecipient[];
  scheduled_at: string;
  appointment_at?: string;
  reminder_days_before?: number;
}
export interface ScheduledSms extends ScheduleJobInput {
  id: string;
  total_recipients: number;
  estimated_cost: number;
  status: ScheduledStatus;
  sent_count: number;
  failed_count: number;
  actual_cost: number;
  error_message: string | null;
  processed_at: string | null;
  created_at: string;
}
